export const IconEyeSlash = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconEyeSlash_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconEyeSlash_svg__a)">
        <path d="M15.175 8.325a4.5 4.5 0 0 1 1.063 1.65q.337.925.237 1.9 0 .375-.275.637a.9.9 0 0 1-.65.263.87.87 0 0 1-.638-.263.87.87 0 0 1-.262-.637q.124-.65-.075-1.25A2.6 2.6 0 0 0 13.95 9.6a2.8 2.8 0 0 0-1.025-.65q-.6-.225-1.275-.1a.85.85 0 0 1-.638-.275.9.9 0 0 1-.262-.65q0-.375.262-.638a.87.87 0 0 1 .638-.262 4.14 4.14 0 0 1 1.875.237 4.5 4.5 0 0 1 1.65 1.063M12 6q-.475 0-.925.037t-.9.138a1.08 1.08 0 0 1-.763-.125 1.02 1.02 0 0 1-.462-.6.94.94 0 0 1 .088-.775q.211-.375.612-.45.574-.125 1.162-.175T12 4q3.424 0 6.262 1.8t4.338 4.85a1.9 1.9 0 0 1 .2.85q0 .225-.038.438-.036.212-.137.412-.45 1-1.113 1.875-.662.875-1.462 1.6a.84.84 0 0 1-.7.225.91.91 0 0 1-.65-.4 1.1 1.1 0 0 1-.212-.763q.037-.412.337-.687.6-.575 1.1-1.25t.875-1.45a9.77 9.77 0 0 0-3.613-4.013A9.55 9.55 0 0 0 12 6m0 13q-3.35 0-6.125-1.812A13 13 0 0 1 1.5 12.425a1.6 1.6 0 0 1-.187-.437 2 2 0 0 1-.063-.488q0-.25.05-.475t.175-.45a13.6 13.6 0 0 1 1.163-1.913Q3.3 7.75 4.15 7L2.075 4.9a.97.97 0 0 1-.263-.713A.98.98 0 0 1 2.1 3.5a.95.95 0 0 1 .7-.275q.425 0 .7.275l17 17q.275.275.288.688a.93.93 0 0 1-.288.712.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-3.5-3.45A12 12 0 0 1 12 19M5.55 8.4q-.725.65-1.325 1.425A9 9 0 0 0 3.2 11.5a9.77 9.77 0 0 0 3.613 4.012A9.55 9.55 0 0 0 12 17q.5 0 .975-.062.475-.063.975-.138l-.9-.95q-.274.075-.525.113A3.5 3.5 0 0 1 12 16q-1.875 0-3.187-1.312Q7.499 13.375 7.5 11.5q0-.274.037-.525.038-.25.113-.525z" />
      </g>
    </svg>
  );
};
